// extracted by mini-css-extract-plugin
export default {"container":"style_container__HZjPl","desc":"style_desc__JKuOa","actionsBox":"style_actionsBox__JfQ1r","actions":"style_actions__D2nsu"};